export const configurationApi = {
  validateServices: 'configurationEndpoint/validateServices',
  originProperties: 'configurationEndpoint/getOriginProperties',
  algoliaFacets: 'configurationEndpoint/getFacetsAlgolia',
  highDemand: 'datafoundation/v3/configurationpopupalgolia/city',
  multiCountry: 'modulesConfiguration',
  internationalization: 'facets-internationalization',
};
